import TransactionsProvider from "providers/TransactionsProvider"
import TransactionsTemplate from "components/templates/TransactionsTemplate"

const Transactions = () => {
  return (
    <TransactionsProvider>
      <TransactionsTemplate />
    </TransactionsProvider>
  )
}

export default Transactions
